export enum SearchType {
  ORDER_NUMBER_ZIP = 'ORDER_NUMBER_ZIP',
  CARD_LAST_FOUR_ZIP = 'CARD_LAST_FOUR_ZIP',
  EMAIL = 'EMAIL',
}

export enum OrderAggregatorErrorCodes {
  FIND_ORDER_NOT_AUTHORIZED = 'FIND_ORDER_NOT_AUTHORIZED',
}

export interface OrdersType {
  hasMore: boolean
  page: number
  size: number
  total: number
  orders: OrderDetailsType[]
}
export interface OrderDetailsType {
  orderNumber: string
  maskedEmail?: string
  isApplePrivateRelay: boolean
  isPlacedByUser: boolean
  orderId: string
  createdAt: string
  products: ProductDetailsType[]
}
export interface ProductDetailsType {
  thumbnailUrl: string
  productId: string
}
